import { useEffect, useState } from "react";

import loadingGreen from "../../images/loading_gray.gif";
import IconWarning from "../../images/icon_warning.svg";
import { FILE_FORMATS, HTTP_METHODS } from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { uploadFileToS3 } from "../../utils/s3Upload";
import FileUploadInput from "../FileUploadInput/FileUploadInput";
import Input from "../Input/Input";
import Modal from "../Modal/Modal";
import {
  Buttons,
  Container,
  MainButton,
} from "./FileUploadAuthorizationModalStyles";

function FileUploadAuthorizationModal(props) {
  const {
    volanteId,
    updateRucOptions,
    updateSelectedRuc,
    otherRucInfo,
    updateVolanteThirdParty,
    onChangeRuc,
    thirdName,
    thirdRuc,
    hideTodoModal,
    hideModalAuthorization,
    showAndHideModalParty,
    showUploadFileModal,
    updateOtherRucInfo,
    setShowConfirmationModalThirdPaty,
    setShowConfirmationModalVolanteDocument,
  } = props;

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [waitingServerResponse, updateWaitingServerResponse] = useState(false);
  const [inputRUC, updateRUC] = useState(
    otherRucInfo ? otherRucInfo.id : thirdRuc
  );
  const [inputCompanyName, updateCompanyName] = useState(
    otherRucInfo ? otherRucInfo.name : thirdName
  );

  const [rucHasError, updateRucHasError] = useState(false);
  const [nameHasError, updateNameHasError] = useState(false);

  const onFileChange = (files) => {
    setSelectedFiles(files);
  };

  const onFileUpload = () => {
    if (waitingServerResponse) return;
    updateNameHasError(false);
    updateRucHasError(false);
    if (inputRUC.length === 0) updateRucHasError(true);
    if (inputCompanyName.length === 0) updateNameHasError(true);
    if (inputRUC.length === 0 || inputCompanyName.length === 0) return;

    updateWaitingServerResponse(true);
    uploadFileToS3(
      "third-party-billing-authorization",
      selectedFiles,
      "autorizacion_facturacion_terceros_"
    )
      .then((urlFile) =>
        updateVolanteRequest(
          volanteId,
          urlFile,
          inputRUC,
          inputCompanyName
        ).then(({ volante }) => {
          if (updateRucOptions) {
            updateRUC("");
            updateCompanyName("");
            setShowConfirmationModalVolanteDocument(true);
            updateRucOptions(volante.billable_ruc_options);
          }
          if (
            updateSelectedRuc &&
            ["reviewing", "approved"].includes(
              volante.third_party_billing_authorization_status.option
            )
          ) {
            updateSelectedRuc("other");
          }
          if (updateVolanteThirdParty) {
            updateVolanteThirdParty(inputCompanyName, inputRUC);
          }
          updateWaitingServerResponse(false);
          setSelectedFiles([]);
          updateRUC("");
          updateCompanyName("");
          updateOtherRucInfo("");
          if (showUploadFileModal) {
            setShowConfirmationModalVolanteDocument(true);
          } else {
            setShowConfirmationModalThirdPaty(true);
          }
        })
      )
      .catch(() => {
        updateWaitingServerResponse(false);
      });
  };
  useEffect(() => {
    updateRUC(otherRucInfo ? otherRucInfo.id : thirdRuc);
    updateCompanyName(otherRucInfo ? otherRucInfo.name : thirdName);
  }, [otherRucInfo, thirdName, thirdRuc]);

  return (
    <>
      {(showAndHideModalParty || showUploadFileModal) && (
        <Modal
          onOutsideClick={() => {
            if (hideTodoModal) {
              updateRUC("");
              updateCompanyName("");
              updateOtherRucInfo("");
              hideTodoModal();
            } else {
              updateRUC("");
              updateCompanyName("");
              hideModalAuthorization();
            }
          }}
        >
          <Container>
            <h1>Autorización de Facturación a Terceros</h1>
            <FileUploadInput
              maxFiles={1}
              onValueChange={onFileChange}
              value={selectedFiles}
              formats={[FILE_FORMATS.IMAGE, FILE_FORMATS.PDF]}
              disabled={waitingServerResponse}
            />
            <label className="input-label" htmlFor="ruc-number">
              RUC DE TERCERO
            </label>
            <Input
              id="ruc-number"
              placeholder={"Ingrese el número de RUC"}
              onChange={(e) => {
                if (!/^\d*$/.test(e.target.value)) return;
                updateRucHasError(false);
                updateRUC(e.target.value);
              }}
              value={inputRUC}
              hasError={rucHasError}
              width="98%"
              disabled={!!otherRucInfo || thirdRuc}
            />
            <label className="input-label" htmlFor="third-party-name">
              RAZÓN SOCIAL DE TERCERO
            </label>
            <Input
              id="third-party-name"
              type="text"
              placeholder={"Razón social del cliente"}
              onChange={(e) => {
                updateNameHasError(false);
                updateCompanyName(e.target.value);
              }}
              value={inputCompanyName}
              hasError={nameHasError}
              width="98%"
              disabled={!!otherRucInfo || thirdName}
            />
            <div className="warning-message">
              <img src={IconWarning} alt="warning" />
              <p>
                Si hay servicios adicionales van a ser borrados hasta que el
                documento sea aprobado o rechazado
              </p>
            </div>
            <Buttons changeRuc={onChangeRuc}>
              {onChangeRuc ? (
                <MainButton changeRuc={true} onClick={onChangeRuc}>
                  Cambiar RUC facturable
                </MainButton>
              ) : null}
              <MainButton
                center={onChangeRuc}
                disabled={selectedFiles.length === 0 || waitingServerResponse}
                onClick={onFileUpload}
              >
                {waitingServerResponse && (
                  <img
                    src={loadingGreen}
                    width="50"
                    height="50"
                    alt="Processing request"
                  />
                )}
                Enviar Documento
              </MainButton>
            </Buttons>
          </Container>
        </Modal>
      )}
    </>
  );
}
export default FileUploadAuthorizationModal;

async function updateVolanteRequest(id, urlFile, ruc, companyName) {
  const response = await networkBackendRequest(
    `/volantes/third-party-billing-authorization/${id}/`,
    HTTP_METHODS.PATCH,
    {},
    {
      third_party_billing_authorization_status_option: "reviewing",
      third_party_billing_authorization_doc: urlFile[0],
      third_party_ruc: ruc,
      third_party_name: companyName,
    }
  );
  return response.json();
}
